/*=========================================================================================
  File Name: store.js
  Description: Vuex store
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

import Vue from "vue";
import Vuex from "vuex";
import createPersistedState from "vuex-persistedstate";
import SecureLS from "secure-ls";
var ls = new SecureLS({ isCompression: false });

Vue.use(Vuex);

import moduleAuth from "./auth/index";
import moduleUI from "./UI/index";
import moduleAdmin from "./Admin/index";
import moduleCategory from "./Category/index";
import download from "./download";

export default new Vuex.Store({
  modules: {
    auth: moduleAuth,
    UI: moduleUI,
    admin: moduleAdmin,
    category:moduleCategory,
    download:download
  },
  strict: process.env.NODE_ENV !== "production",
  plugins: [
    createPersistedState({
      storage: {
        getItem: (key) => ls.get(key),
        setItem: (key, value) => ls.set(key, value),
        removeItem: (key) => ls.remove(key),
      },
    }),
  ],
});

// window.ls = ls;

// export { ls };
